enum ActionTypes {
  SIGN_DOCUMENT = 'Signature/SIGN_DOCUMENT',
  SIGN_DOCUMENT_REQUEST = 'Signature/SIGN_DOCUMENT_REQUEST',
  SIGN_DOCUMENT_SUCCESS = 'Signature/SIGN_DOCUMENT_SUCCESS',
  SIGN_DOCUMENT_FAILURE = 'Signature/SIGN_DOCUMENT_FAILURE',
  SIGN_DOCUMENT_UPDATE = 'Signature/SIGN_DOCUMENT_UPDATE',
}

export default ActionTypes;
